import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AjaxService } from '../../../core/services/ajax.service';

@Injectable()
export class DashboardService {
    baseUrl: string = 'Dashboard.svc';
    constructor(private http: Http, private _ajaxService: AjaxService) {
    }

    selectDashboardTiles() {
        return this._ajaxService.GET(this.baseUrl + "/SelectDashboardTiles");
    }

    all(roleId) {
        return this._ajaxService.GET(this.baseUrl + "/all/" + roleId);
    }

    orders(distributorId, orderDateColumnId) {
        return this._ajaxService.GET(this.baseUrl + "/orders/" + distributorId +"/"+ orderDateColumnId);
    }

    save(dataToBePost) {        
        return this._ajaxService.POST(this.baseUrl + "/save", dataToBePost);        
    }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/services/dashboard.service.ts